import script from "./FilesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FilesPage.vue?vue&type=script&setup=true&lang=js"

import "./FilesPage.vue?vue&type=style&index=0&id=217a96e3&lang=css"

const __exports__ = script;

export default __exports__